import { Component, Inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle
} from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";
import { Mood } from "@teammood/timeline";

@Component({
    selector: 'tm-save-comment-dialog',
    templateUrl: 'save-comment-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatDialogTitle,
        TranslateModule,
        MatDialogContent,
        MatDialogActions,
    ]
})
export class TmSaveCommentDialogComponent implements OnInit {

    constructor(
        @Inject(MAT_DIALOG_DATA) protected data: SaveCommentDialogData,
        private dialogRef: MatDialogRef<TmSaveCommentDialogComponent>,
    ) {}

    ngOnInit() {
    }

    protected onClose() {
        this.dialogRef.close();
    }

    protected saveComment(){
        this.dialogRef.close(this.data.mood);
    }
}

interface SaveCommentDialogData {
    mood: Mood;
}